module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"more":"See more","description":"Fill missing product information in order to improve Dynameat predictions"},"es":{"more":"Ver más","description":"Completa la información de tus productos para mejorar las predicciones de Dynameat"}}')
  delete Component.options._Ctor
}
